// Cookie consent for analytics and advertising tags. Necessary storage (sign-in,
// the CV draft, preferences) is always on and isn't covered here.
//
// Nothing non-essential loads until the visitor has chosen. The choice lives in
// localStorage and is broadcast on window so the tag loader and the banner stay
// in sync without a React context.

export type Consent = {
  v: 1
  analytics: boolean
  ads: boolean
  at: string
}

const CONSENT_KEY = 'cvcircuit:consent'
export const CONSENT_CHANGED_EVENT = 'cvcircuit:consent-changed'
export const OPEN_CONSENT_EVENT = 'cvcircuit:open-consent'

export function getConsent(): Consent | null {
  try {
    const raw = localStorage.getItem(CONSENT_KEY)
    if (!raw) return null
    const parsed = JSON.parse(raw)
    if (parsed?.v !== 1) return null
    return { v: 1, analytics: parsed.analytics === true, ads: parsed.ads === true, at: String(parsed.at || '') }
  } catch {
    return null
  }
}

export function setConsent(choice: { analytics: boolean; ads: boolean }) {
  const previous = getConsent()
  const next: Consent = { v: 1, analytics: choice.analytics, ads: choice.ads, at: new Date().toISOString() }
  try { localStorage.setItem(CONSENT_KEY, JSON.stringify(next)) } catch { }
  window.dispatchEvent(new CustomEvent(CONSENT_CHANGED_EVENT, { detail: { previous, next } }))
}

export function openConsentSettings() {
  window.dispatchEvent(new Event(OPEN_CONSENT_EVENT))
}
